import { InputAdornment, Typography } from "@mui/material";

/**
 * The unit of whatever the field holds, inside the input rather than in its
 * label. The config sidebar puts label and input side by side in a narrow
 * column, so "Price (¥/kWh)" as a label wraps; as an adornment it sits with the
 * value it qualifies and costs the label nothing.
 */
export const UnitAdornment = ({ unit }: { unit: string }) => (
  <InputAdornment position="end">
    <Typography
      component="span"
      sx={{ fontSize: "0.75rem", color: "text.secondary", userSelect: "none" }}
    >
      {unit}
    </Typography>
  </InputAdornment>
);
